import { render, staticRenderFns } from "./ArchivedCategories.vue?vue&type=template&id=266f9e08&"
import script from "./ArchivedCategories.vue?vue&type=script&lang=js&"
export * from "./ArchivedCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCategories.vue?vue&type=style&index=0&id=266f9e08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports